module.exports = __webpack_public_path__ + "img/express-nodejs-logo.090d6e93.png";